var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function () {
    angular
        .module('QMC.Arbeitszeitnachweis')
        .config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('azn', {
            url: '/azn',
            templateUrl: qmcBase + '/Arbeitszeitnachweis',
            controller: 'ArbeitszeitnachweisListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: AZN.LIST');
                    }]
            }
        })
            .state('aznnew', {
            url: '/azn/new',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/New',
            controller: 'ArbeitszeitnachweisNewController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: AZN.NEW');
                    }]
            }
        })
            .state('azndetail', {
            url: '/azn/detail/:id',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/New',
            controller: 'ArbeitszeitnachweisNewController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current state: AZN.DETAIL');
                    }]
            }
        })
            .state('aznoverview', {
            url: '/azn/overview',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/Overview',
            controller: 'ArbeitszeitnachweisOverviewController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current state: AZN Overview');
                    }]
            }
        })
            .state('manualovertime', {
            url: '/manualovertime',
            templateUrl: qmcBase + '/Arbeitszeitnachweis/ManualOvertime',
            controller: 'ManualOvertimeListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: ManualOvertime');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Arbeitszeitnachweis.HttpProvider = HttpProvider;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Arbeitszeitnachweis')
        .config(['$httpProvider', QMC.Arbeitszeitnachweis.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var TimeTrackingConstants = /** @class */ (function () {
            function TimeTrackingConstants() {
            }
            TimeTrackingConstants.TIME_TRACKING_STAMP_IN = '829F4DFB-F4E0-4921-8AC1-8C4F83952593';
            TimeTrackingConstants.TIME_TRACKING_STAMP_OUT = '04C5C2E9-1485-4466-BF46-DE4428DD3DA7';
            return TimeTrackingConstants;
        }());
        Arbeitszeitnachweis.TimeTrackingConstants = TimeTrackingConstants;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var AznwService = /** @class */ (function (_super) {
            __extends(AznwService, _super);
            function AznwService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Arbeitszeitnachweis';
                return _this;
            }
            AznwService.prototype.getArbeitszeitnachweisRequiredFields = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/RequiredFields', {}, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getArbeitszeitnachweisList = function (dateFrom, dateTo, page, pageSize) {
                if (page === void 0) { page = -1; }
                if (pageSize === void 0) { pageSize = -1; }
                return _super.prototype.getPagination.call(this, this.modulePath, { dateFrom: dateFrom, dateTo: dateTo, page: page, pageSize: pageSize }, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getArbeitszeitnachweis = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getAllocatableFlsCaseList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/AllocatableFlsCases', {}, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getArbeitzeitnachweisWv = function (date) {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', { date: date }, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getUserConfig = function (date, aznId) {
                return _super.prototype.getItem.call(this, this.modulePath + '/UserConfig', { date: date, aznId: aznId }, function (data) {
                    return data;
                });
            };
            AznwService.prototype.postArbeitszeitnachweis = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (e) {
                    return e;
                });
            };
            AznwService.prototype.putArbeitszeitnachweis = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id, data).then(function (e) {
                    return e;
                });
            };
            AznwService.prototype.deleteArbeitszeitnachweis = function (id) {
                console.log("LÖSCHEN !!!");
                return _super.prototype.delete.call(this, this.modulePath + '/' + id).then(function (data) {
                    return data;
                });
            };
            AznwService.prototype.deleteAllFlsAllocations = function (aznId) {
                _super.prototype.delete.call(this, this.modulePath + '/' + aznId + '/DeleteAllFlsAllocations');
            };
            AznwService.prototype.checkForWarningsAndErrors = function (data) {
                return _super.prototype.getItem.call(this, this.modulePath + '/WarningsAndErrors', data, function (data) {
                    return data;
                });
            };
            ///////////////// Workingtime Overview /////////////////
            AznwService.prototype.getWorkingtimeCalculation = function (date, personId, organisationId, targetView) {
                return _super.prototype.getItem.call(this, this.modulePath + '/WorkingTimeOverview', { date: date, personId: personId, organisationId: organisationId, targetView: targetView }, function (data) {
                    return data;
                });
            };
            AznwService.prototype.getWorkingTimeOverviewOptions = function (date, personId) {
                return _super.prototype.getItem.call(this, this.modulePath + '/WorkingTimeOverviewOptions', { date: date, personId: personId }, function (data) {
                    return data;
                });
            };
            ///////////////////// WeekPlanning /////////////////////
            AznwService.prototype.getAznWeekPlanning = function (dateFrom, dateTo, showOnlyOwn, showDocumented, personId) {
                return _super.prototype.get.call(this, this.modulePath + '/WeekPlanning', { dateFrom: dateFrom, dateTo: dateTo, showOnlyOwn: showOnlyOwn, showDocumented: showDocumented, personId: personId }, function (data) {
                    return data;
                });
            };
            AznwService.prototype.postAznWeekPlanning = function (data) {
                if (!Array.isArray(data))
                    data = [data];
                return _super.prototype.post.call(this, this.modulePath + '/WeekPlanning', data).then(function (e) {
                    return e;
                });
            };
            AznwService.prototype.putAznWeekPlanning = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/WeekPlanning/' + id, data).then(function (e) {
                    return e;
                });
            };
            AznwService.prototype.deleteAznWeekPlanning = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/WeekPlanning/' + id).then(function (data) {
                    return data;
                });
            };
            AznwService = __decorate([
                QMC.Service('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisService'),
                QMC.Inject('$http', '$q')
            ], AznwService);
            return AznwService;
        }(QMC.Common.BaseService));
        Arbeitszeitnachweis.AznwService = AznwService;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var ArbeitszeitnachweisListController = /** @class */ (function () {
            /**
             * QMC.Arbeitszeitnachweis.AzwnController
             * @constructor
             * @param arbeitszeitnachweisService
             * @param $qui
             * @param $stateParams
             */
            function ArbeitszeitnachweisListController($location, $scope, arbeitszeitnachweisService, $qui, $stateParams, userService, permissionService) {
                var _this = this;
                this.$location = $location;
                this.$scope = $scope;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.permissionService = permissionService;
                this.allowTableExport = false;
                this.pagination = [];
                this.filter = {
                    dateFrom: moment().startOf('months').toDate(),
                    dateTo: moment().endOf('months').toDate(),
                };
                this.showMonthFilter = true;
                this.showTime = false;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.setTableSchema();
                localStorage.removeItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                if (document.getElementById("permissions").getAttribute("arbeitszeitnachweis").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module arbeitszeitnachweis");
                    this.forbidden = true;
                    return;
                }
                //ObjectType: ArbeitszeitnachweisPlugin
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectType(425000).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.view = data[0].view && data[0].moduleAccess;
                    _this.allowTableExport = data[0].print;
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        _this.userService.getUserSettings(["FLS.SHOWMONTHFILTER", "SHOWTIMEINSTEADOFDECIMAL"]).then(function (data) {
                            _this.showMonthFilter = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS : data[0].value.toLowerCase() === "true";
                            _this.showTime = data[1].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[1].value.toLowerCase() === "true";
                            _this.page = 0;
                            if ($stateParams.page !== (undefined || null)) {
                                _this.page = Number($stateParams.page);
                            }
                            if (_this.shouldLoadTableData) {
                                _this.getData();
                                _this.init();
                            }
                            // make sure scope gets updated if not already in progress
                            _this.$qui.scopeApply(_this.$scope);
                        });
                    });
                    _this.permissionLoading = false;
                });
            }
            ArbeitszeitnachweisListController.prototype.getData = function () {
                this.setPage(this.page);
            };
            ArbeitszeitnachweisListController.prototype.setTableSchema = function () {
                this.aznTable = {
                    "config": {
                        "tableRowLink": "#/azn/detail/{{objectId}}",
                    },
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "withTime": "true",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "withTime": "true",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Art": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "21005005"
                        },
                        "Dauer": {
                            "label": "durationInHours",
                            "dType": "Time",
                            "calculate": "true",
                            "lngTag": "20000075"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-history2"
                        },
                        "text": {
                            "label": "type",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "dateFrom",
                                "withTime": "true",
                                "dType": "Date"
                            },
                            {
                                "label": "dateTo",
                                "withTime": "true",
                                "dType": "Date"
                            }
                        ],
                        "buttons": {
                            "icon": "qm-icon-pencil blue",
                            "href": "#/azn/detail/{{objectId}}",
                            "label": "data",
                            "dType": "Button",
                            "tooltip": "Bearbeiten",
                            "lngTag": "20000044",
                            "permission": "modify"
                        }
                    },
                    "data": null,
                };
            };
            /**
             * init
             * @description Init the filter
             */
            ArbeitszeitnachweisListController.prototype.init = function () {
                var _this = this;
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    console.log('#### filterWatcher');
                    _this.getAznList();
                });
            };
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * setPage
             * @description Set the current paginated page
             * @param page The current page
             */
            ArbeitszeitnachweisListController.prototype.setPage = function (page) {
                console.log('#### setPage');
                this.page = page;
                this.getAznList();
            };
            /**
             * setPagination
             * @description Create a Pagination object for the view
             */
            ArbeitszeitnachweisListController.prototype.setPagination = function () {
                console.log('#### setPagination aznListController');
                this.pagination = [];
                for (var i = 1; i <= Number(this.aznList.paginationInfo.totalPages); i++) {
                    this.pagination.push(i);
                }
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * getAznList()
             * @description Get the azn list by a date range from API
             */
            /*private abc : any;*/
            ArbeitszeitnachweisListController.prototype.getAznList = function () {
                var _this = this;
                console.log('### getAZNList');
                this.loading = true;
                this.arbeitszeitnachweisService.getArbeitszeitnachweisList(this.filter.dateFrom, this.filter.dateTo).then(function (data) {
                    _this.aznTable.data = data.items;
                    _this.$qui.functionWaiter("createTable", _this);
                    _this.loading = false;
                });
            };
            ArbeitszeitnachweisListController = __decorate([
                QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisListController'),
                QMC.Inject('$location', '$scope', 'ArbeitszeitnachweisService', '$qui', '$stateParams', 'UserService', 'QmcPermissionService')
            ], ArbeitszeitnachweisListController);
            return ArbeitszeitnachweisListController;
        }());
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
/// <reference path="../../../QMC.Web.Fachleistung/AppScripts/Fachleistung/fachleistung.ui.ts" />
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var ArbeitszeitnachweisNewController = /** @class */ (function () {
            function ArbeitszeitnachweisNewController($location, arbeitszeitnachweisService, $qui, $scope, $state, $timeout, identityService, userService, lng, permissionService) {
                var _this = this;
                this.$location = $location;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.$timeout = $timeout;
                this.identityService = identityService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.caseSearchText = "";
                this.disable = true;
                this.caseFilter = QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_DEFAULTS;
                this.saving = false;
                this.defaultActivity = QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                this.casesToShow = [];
                this.loadingUserConfig = true;
                this.timeFormSchema = {
                    form: [
                        {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            startDate: null,
                            endDate: null,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo",
                                durationInHours: "durationInHours"
                            },
                            style: {
                                class: "col-xs-12 col-md-12"
                            },
                            config: {
                                displayDateTo: true,
                                displayTime: true,
                                dateToRequired: true,
                                roundInterval: 0,
                                startRoundType: null,
                                endRoundType: null,
                                disableTime: "isManualDuration",
                            }
                        },
                        {
                            label: "Dauer",
                            model: "timeString",
                            lngTag: 20000075,
                            type: "String",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-clock-o"
                            },
                            events: {
                                hide: "isManualDuration"
                            }
                        },
                        {
                            label: "Stunden",
                            model: "hours",
                            type: "Number",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Minuten",
                            type: "Number",
                            model: "minutes",
                            style: {
                                class: "col-xs-6 col-md-3"
                            },
                            events: {
                                hideExpression: "!(qmForm.isManualDuration)"
                            }
                        },
                        {
                            label: "Manuelle Dauer",
                            type: "Checkbox",
                            lngTag: 20000213,
                            model: "isManualDuration",
                            id: "isManualDuration",
                            style: {
                                class: "col-lg-4 col-xs-12 col-md-12"
                            },
                            events: {
                                hideExpression: "!(qmScopeCallback().isManualDuration) && !(qmForm.isManualTimeAllowed)"
                            }
                        }
                    ]
                };
                this.commentFormSchema = {
                    form: [
                        {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ]
                };
                $qui.init($qui.getSectionColor("/azn"), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("arbeitszeitnachweis").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                var previousStateCache = localStorage.getItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                if (previousStateCache !== null) {
                    this.returnState = JSON.parse(previousStateCache);
                }
                else {
                    this.returnState = {
                        state: "azn",
                        params: []
                    };
                }
                localStorage.removeItem(QMC.Common.LocalStorageConstants.AZN_PREVIOUS_STATE);
                //ObjectType: ArbeitszeitnachweisPlugin
                permissionService.getPermissionsByObjectTypes([425000, 411011]).then(function (data) {
                    _this.deletePermission = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.view = data[0].view && data[0].moduleAccess;
                    _this.allocationPermissions = {
                        delete: data[1].delete && data[1].moduleAccess,
                        modify: data[1].modify && data[1].moduleAccess,
                        new: data[1].new && data[1].moduleAccess,
                        view: data[1].view && data[1].moduleAccess
                    };
                });
                this.formState = 'new';
                this.cases = [];
                this.userService.getUserSettings(["FLS.DEFAULTACTIVITYTYPE"], false).then(function (data) {
                    var _a;
                    if (((_a = data[0].value) === null || _a === void 0 ? void 0 : _a.length) && data[0].value !== QMC.Common.Constants.GUID_EMPTY)
                        _this.defaultActivity = data[0].value;
                }).finally(function () {
                    _this.edit = _this.$state.params.hasOwnProperty('id');
                    _this.initForm();
                    if (_this.edit) {
                        _this.edit = true;
                        _this.clientId = _this.$state.params.id;
                        _this.loading = true;
                        _this.getDetailData(_this.$state.params.id);
                    }
                    else {
                        _this.initTime();
                        _this.events();
                    }
                });
                this.userService.getUserSettings(["AZN.SHOWDATETO", "SHOWTIMEINSTEADOFDECIMAL", QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY]).then(function (data) {
                    _this.dateToEnabled = data[0].value.toLowerCase() === "true";
                    _this.showTime = data[1].value.toLowerCase() === "true";
                    _this.timeFormSchema.form[0].config.displayDateTo = _this.dateToEnabled;
                    _this.caseFilter = data[2].value === '' ? _this.caseFilter : JSON.parse(data[2].value);
                    _this.getAlloCaseList();
                });
                this.promptOptions = {
                    title: "Arbeitszeitnachweis",
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                };
            }
            ArbeitszeitnachweisNewController.prototype.events = function () {
                var _this = this;
                this.$qui.functionWaiter("createForm", this);
                this.$qui.functionWaiter("createCommentForm", this);
                this.$scope.$watch('vm.timeForm.dateFrom', function (newVal, oldVal) {
                    if (moment(newVal).format('L') !== moment(oldVal).format('L'))
                        _this.getAznWvList();
                    _this.validate();
                });
                this.$scope.$watch('vm.timeForm.dateTo', function () {
                    _this.validate();
                });
                this.$scope.$watch('vm.form.typeWvId', function () {
                    _this.validate();
                });
                this.$scope.$watch('vm.form.activityId', function () {
                    _this.validate();
                });
                this.$scope.$watch('vm.form.instituteId', function () {
                    _this.validate();
                });
                this.$scope.$watch('vm.form.isImpute', function () {
                    _this.validate();
                });
                this.$scope.$watch('vm.form.reasonWvId', function (newVal, oldVal) {
                    if (newVal === oldVal || !_this.form.isReasonRequired)
                        return;
                    _this.validate();
                });
                this.$scope.$watch('vm.timeForm.durationInHours', function () {
                    if (_this.showTime) {
                        var conv = _this.$qui.convertDec(_this.timeForm.durationInHours);
                        var minutes = conv[1].toString();
                        if (conv[1] < 10)
                            minutes = "0" + minutes;
                        _this.timeForm.timeString = conv[0] + ":" + minutes;
                    }
                    else {
                        if (_this.timeForm.durationInHours) {
                            _this.timeForm.timeString = _this.timeForm.durationInHours.toFixed(2).toString().replace('.', ',');
                        }
                    }
                });
                this.$scope.$watch('vm.timeForm.hours', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.manualTimeWatch();
                }, true);
                this.$scope.$watch('vm.timeForm.minutes', function (newVal, oldVal) {
                    if (newVal === oldVal)
                        return;
                    _this.manualTimeWatch();
                }, true);
            };
            ArbeitszeitnachweisNewController.prototype.manualTimeWatch = function () {
                if (!this.timeForm.isManualDuration)
                    return;
                var hours = this.cleanInputNumber(this.timeForm.hours);
                var minutes = this.cleanInputNumber(this.timeForm.minutes);
                while (minutes >= 60) {
                    minutes = minutes - 60;
                    hours = hours + 1;
                }
                this.timeForm.hours = hours;
                this.timeForm.minutes = minutes;
                //this.validate(); //commented since azn currently dont validate manual time, so dont bother the server
            };
            ArbeitszeitnachweisNewController.prototype.cleanInputNumber = function (inputNumber) {
                //remove commas and leading minus characters and
                //possibility to remove content of input box completely
                if (isNaN(inputNumber)) {
                    inputNumber = 0;
                }
                //kill leading zeros
                inputNumber = +inputNumber;
                return Math.round(inputNumber);
            };
            /**
             * Init the form, set default properties.
             *
             * @private
             *
             * @memberOf ArbeitszeitnachweisNewController
             */
            ArbeitszeitnachweisNewController.prototype.initForm = function () {
                this.form = {
                    //dateFrom: moment().hours(8).minutes(0).toDate(),
                    //dateTo: moment().hours(8).minutes(0).toDate(),
                    durationInHours: null,
                    kuerzel: this.lng.translate(21005000, "Arbeitszeitnachweis").charAt(0),
                    caption: this.lng.translate(21005000, "Arbeitszeitnachweis"),
                    organizationObjectId: QMC.Common.Constants.GUID_EMPTY,
                    activityId: this.defaultActivity,
                    typeWvId: QMC.Common.Constants.GUID_EMPTY,
                    imputeWvId: QMC.Common.Constants.GUID_EMPTY,
                    isImpute: false,
                    reasonWvId: QMC.Common.Constants.GUID_EMPTY,
                    flsAllocations: [],
                    isManualDuration: false,
                    minimalStartHour: 0,
                    maximalStartHour: 0,
                    timeSetMinuteInterval: 0,
                    startRoundType: 0,
                    endRoundType: 0,
                    hasStartHourRounding: false,
                    hasEndHourRound: false,
                    defaultHour: 0,
                    isManualTimeAllowed: true,
                    comment: "",
                    isActivityStandardValidValue: QMC.Common.Constants.GUID_EMPTY,
                    isReasonRequired: false,
                    isCareTypeRequiered: false,
                    isContactTypeRequiered: false,
                    fixActivityId: QMC.Common.Constants.GUID_EMPTY,
                    performingPersonObjectId: $('#session').data().personId
                };
                this.form.flsAllocations.watcherList = [];
                this.timeForm = {
                    //dateFrom: this.form.dateFrom,
                    //dateTo: this.form.dateTo,
                    hours: 0,
                    minutes: 0,
                    isManualDuration: false,
                    isManualTimeAllowed: true
                };
                this.initTime();
                if (!this.edit)
                    this.getAznWvList();
            };
            ArbeitszeitnachweisNewController.prototype.initTime = function () {
                this.form.dateTo = moment().minutes(0).toDate();
                this.form.dateTo.setSeconds(0);
                this.form.dateTo.setMilliseconds(0);
                this.form.dateFrom = moment().minutes(0).toDate();
                this.form.dateFrom.setHours(this.form.dateFrom.getHours() - 1);
                this.timeForm.dateFrom = this.form.dateFrom;
                this.timeForm.dateTo = this.form.dateTo;
            };
            ArbeitszeitnachweisNewController.prototype.convertDate = function (dateFrom, dateTo) {
                if (dateTo < dateFrom)
                    dateFrom = [dateTo, dateTo = dateFrom][0];
                return [dateFrom, dateTo];
            };
            ArbeitszeitnachweisNewController.prototype.addToList = function (object) {
                var _this = this;
                if (this.form.flsAllocations === null) {
                    this.form.flsAllocations = [];
                    this.form.flsAllocations.watcherList = [];
                }
                object.percentShare = 0;
                this.form.flsAllocations.push(object);
                this.removeFromListById(object.flsCaseId);
                var index = this.form.flsAllocations.length - 1;
                this.form.flsAllocations.watcherList.push(this.$scope.$watch('vm.form.flsAllocations[' + index + '].percentShare', function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.validate();
                }));
                this.devideShares();
            };
            ArbeitszeitnachweisNewController.prototype.removeFromList = function (object) {
                for (var i = 0; i < this.form.flsAllocations.length; i++) {
                    if (this.form.flsAllocations[i].flsCaseId === object.flsCaseId) {
                        this.form.flsAllocations.splice(i, 1);
                    }
                }
                this.cases.push(object);
                this.devideShares();
            };
            ArbeitszeitnachweisNewController.prototype.enableAllocationEdit = function () {
                if (this.formState === 'edit') {
                    return this.allocationPermissions.modify;
                }
                else if (this.formState === 'new') {
                    return this.allocationPermissions.new;
                }
            };
            ArbeitszeitnachweisNewController.prototype.showAllocation = function () {
                return this.showFlsAllocation && ((this.formState === 'new' && this.allocationPermissions.new) || (this.formState === 'edit' && this.allocationPermissions.view));
            };
            ArbeitszeitnachweisNewController.prototype.getUserConfig = function () {
                var _this = this;
                this.arbeitszeitnachweisService.getArbeitszeitnachweisRequiredFields().then(function (data) {
                    _this.form.isReasonRequired = data.reasonWvId;
                });
                this.arbeitszeitnachweisService.getUserConfig(this.timeForm.dateFrom, this.form.objectId).then(function (data) {
                    var tmp = {
                        form: __assign({}, _this.form),
                        timeForm: __assign({}, _this.timeForm)
                    };
                    if (_this.formState !== 'edit')
                        tmp.form.isImpute = data.anrechnenDefaultValue === QMC.Common.Constants.WV_YES;
                    _this.isAnrechnenEditable = data.isAnrechnenEditable;
                    _this.showFlsAllocation = data.showFlsAllocation;
                    tmp.form.isManualTimeAllowed = data.isManualTimeAllowed;
                    //override the isManualDuration when you create a new azn with isManualTimeAllowed
                    tmp.form.isManualDuration = tmp.form.isManualTimeAllowed;
                    tmp.timeForm.isManualTimeAllowed = data.isManualTimeAllowed;
                    tmp.form.isActivityStandardValidValue = data.isActivityStandardValidValue;
                    tmp.form.isCareTypeRequiered = data.isCareTypeRequiered;
                    tmp.form.isContactTypeRequiered = data.isContactTypeRequiered;
                    tmp.form.fixActivityId = data.fixActivityId;
                    if (data.fixActivityId && data.fixActivityId !== QMC.Common.Constants.GUID_EMPTY) {
                        tmp.form.activityId = data.fixActivityId;
                    }
                    tmp.form.minimalStartHour = data.minimalStartHour;
                    tmp.form.maximalStartHour = data.maximalStartHour;
                    tmp.form.timeSetMinuteInterval = data.timeSetMinuteInterval;
                    tmp.form.startRoundType = data.startRoundingType;
                    tmp.form.endRoundType = data.endRoundingType;
                    tmp.form.hasStartHourRounding = data.hasStartHourRounding;
                    tmp.form.hasEndHourRound = data.hasEndHourRound;
                    tmp.form.defaultHour = data.defaultHour;
                    if (!_this.$state.params.hasOwnProperty('id')) {
                        tmp.timeForm.dateFrom.setHours(data.defaultHour);
                        tmp.timeForm.dateFrom.setMinutes(0);
                        tmp.timeForm.dateTo.setHours(data.defaultHour + 1);
                        tmp.timeForm.dateTo.setMinutes(0);
                        _this.timeFormSchema.form[0].config.roundInterval = data.hasStartHourRounding || data.hasEndHourRound ? tmp.form.timeSetMinuteInterval : 0;
                        _this.timeFormSchema.form[0].config.startRoundType = data.hasStartHourRounding ? tmp.form.startRoundType : null;
                        _this.timeFormSchema.form[0].config.endRoundType = data.hasEndHourRound ? tmp.form.endRoundType : null;
                    }
                    _this.form = tmp.form;
                    _this.timeForm = tmp.timeForm;
                    _this.$timeout(function () {
                        if (!_this.edit)
                            _this.form.instituteId = data.defaultInstituteId;
                    });
                }).finally(function () {
                    _this.loadingUserConfig = false;
                    _this.validate();
                });
            };
            ArbeitszeitnachweisNewController.prototype.removeFromListById = function (id) {
                this.cases = this.cases.filter(function (y) { return y.flsCaseId !== id; });
            };
            ArbeitszeitnachweisNewController.prototype.devideShares = function () {
                var percent = 100 / this.form.flsAllocations.length;
                for (var _i = 0, _a = this.form.flsAllocations; _i < _a.length; _i++) {
                    var element = _a[_i];
                    element.percentShare = percent;
                }
            };
            ArbeitszeitnachweisNewController.prototype.getSharedValue = function () {
                var _a;
                if (!((_a = this.form) === null || _a === void 0 ? void 0 : _a.flsAllocations))
                    return 100;
                var flsAllocationsValue = 0;
                if (this.form.flsAllocations) {
                    for (var _i = 0, _b = this.form.flsAllocations; _i < _b.length; _i++) {
                        var element = _b[_i];
                        flsAllocationsValue += Number(element.percentShare);
                    }
                }
                // round to 5th decimal position
                flsAllocationsValue = Math.round(flsAllocationsValue * 10000) / 10000;
                return Number(flsAllocationsValue.toFixed(5));
            };
            ArbeitszeitnachweisNewController.prototype.validate = function () {
                var _a;
                var _this = this;
                if (this.loadingUserConfig || !this.timeForm.dateFrom || !this.timeForm.dateTo)
                    return;
                if (this.lastValidation && (this.lastValidation.timeForm == JSON.stringify(this.timeForm) && this.lastValidation.form == JSON.stringify(this.form)))
                    return;
                var randomId = this.$qui.generateGuid();
                this.lastValidation = {
                    timeForm: JSON.stringify(this.timeForm),
                    form: JSON.stringify(this.form),
                    randomId: randomId
                };
                this.checkLoad = true;
                var dateFrom, dateTo;
                _a = this.convertDate(this.timeForm.dateFrom, this.timeForm.dateTo), dateFrom = _a[0], dateTo = _a[1];
                this.warnings = { warnings: [], errors: [], isLoading: true };
                var validateParam = {
                    idObjectAznw: this.form.objectId,
                    dateFrom: moment(dateFrom).format(),
                    dateTo: moment(dateTo).format(),
                    performingPersonObjIdList: this.form.performingPersonObjectId,
                    isPlanned: false,
                    activityId: this.form.activityId,
                    imputeWvId: this.form.isImpute ? QMC.Common.Constants.WV_YES : QMC.Common.Constants.WV_NO,
                    instituteId: this.form.instituteId
                };
                this.arbeitszeitnachweisService.checkForWarningsAndErrors(validateParam)
                    .then(function (data) {
                    if (randomId !== _this.lastValidation.randomId)
                        return;
                    _this.warnings = __assign(__assign({}, data), { isLoading: false });
                    if (_this.form.typeWvId === null || _this.form.typeWvId === QMC.Common.Constants.GUID_EMPTY)
                        _this.warnings.errors.push(_this.lng.translate(21005040, "Der Arbeitzeitnachweis benötigt eine Art."));
                    if (_this.getSharedValue() !== 100 && _this.form.flsAllocations && _this.form.flsAllocations.length > 0)
                        _this.warnings.warnings.push(_this.lng.translate(21005053, "Die Summe aller FLS Zuordnungen ist ungleich 100 Prozent."));
                    if (_this.timeForm.dateTo < _this.timeForm.dateFrom)
                        _this.warnings.errors.push(_this.lng.translate(20002004, "Das Startdatum ist größer als das Enddatum."));
                    if (!_this.form.instituteId || _this.form.instituteId === QMC.Common.Constants.GUID_EMPTY)
                        _this.warnings.errors.push(_this.lng.translate(21005047, "Es muss ein Erbringungsort angegeben werden."));
                    if (_this.form.isReasonRequired && _this.form.reasonWvId === QMC.Common.Constants.GUID_EMPTY)
                        _this.warnings.errors.push(_this.lng.translate(21005054, "Es muss ein Grund angegeben werden."));
                }).catch(function (e) {
                    _this.warnings = {
                        errors: [e],
                        warnings: [],
                        isLoading: false
                    };
                }).finally(function () {
                    _this.checkLoad = false;
                });
            };
            ArbeitszeitnachweisNewController.prototype.saveThough = function () {
                $('#validationModal').modal('toggle');
                if ($('.modal-backdrop') !== null)
                    $('.modal-backdrop').remove();
                if (this.edit)
                    this.editAzn();
                else
                    this.postAzn();
            };
            ArbeitszeitnachweisNewController.prototype.saveAzn = function () {
                this.form.dateFrom = this.timeForm.dateFrom;
                this.form.dateTo = this.timeForm.dateTo;
                this.form.isManualDuration = this.timeForm.isManualDuration;
                this.form.isManualTimeAllowed = this.timeForm.isManualTimeAllowed;
                this.form.durationInHours = this.convertHours(this.timeForm.hours, this.timeForm.minutes);
                this.form.imputeWvId = this.form.isImpute ? QMC.Common.Constants.WV_YES : QMC.Common.Constants.WV_NO;
                if (this.warnings.warnings.length + this.warnings.errors.length === 0) {
                    if (this.edit)
                        this.editAzn();
                    else
                        this.postAzn();
                }
                else {
                    $('#validationModal').modal('toggle');
                }
            };
            ArbeitszeitnachweisNewController.prototype.postAzn = function () {
                var _this = this;
                if (this.form.typeWvId === QMC.Common.Constants.GUID_EMPTY) {
                    this.$qui.notify({
                        message: this.lng.translate(20002035, "Die Art muss ausgewählt werden!"),
                        title: this.lng.translate(20002015, "Fehler"),
                        icon: "qm-icon-times",
                        status: "warning",
                        timer: 3500
                    });
                    return;
                }
                this.saving = true;
                setTimeout(function () {
                    _this.arbeitszeitnachweisService.postArbeitszeitnachweis(_this.form).then(function (data) {
                        _this.$qui.notify(_this.$qui.successNote);
                        _this.$state.go(_this.returnState.state, _this.returnState.params);
                        _this.saving = false;
                    });
                }, 250);
            };
            ArbeitszeitnachweisNewController.prototype.editAzn = function () {
                var _this = this;
                this.form.dateFrom = this.timeForm.dateFrom;
                this.form.dateTo = this.timeForm.dateTo;
                this.form.isManualDuration = this.timeForm.isManualDuration;
                this.form.isManualTimeAllowed = this.timeForm.isManualTimeAllowed;
                this.form.durationInHours = this.convertHours(this.timeForm.hours, this.timeForm.minutes);
                this.saving = true;
                this.arbeitszeitnachweisService.putArbeitszeitnachweis(this.clientId, this.form).then(function (data) {
                    _this.$qui.notify(_this.$qui.successNote);
                    _this.$state.reload();
                    _this.$state.go(_this.returnState.state, _this.returnState.params);
                    _this.saving = false;
                });
            };
            ArbeitszeitnachweisNewController.prototype.delete = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data) {
                        _this.saving = true;
                        _this.arbeitszeitnachweisService.deleteArbeitszeitnachweis(_this.form.objectId).then(function (data) {
                            _this.$qui.notify(_this.$qui.deleteNote);
                            _this.$state.reload();
                            _this.$state.go(_this.returnState.state, _this.returnState.params);
                            _this.saving = false;
                        });
                    }
                });
            };
            ArbeitszeitnachweisNewController.prototype.getAznWvList = function () {
                var _this = this;
                this.arbeitszeitnachweisService.getArbeitzeitnachweisWv(this.timeForm.dateFrom).then(function (data) {
                    var _a, _b;
                    var previousWv = angular.copy(_this.aznWvList);
                    _this.aznWvList = data;
                    _this.aznTypes = data.types.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    _this.reasonTypes = data.reasons.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                    _this.getUserConfig();
                    _this.validate();
                    if (!_this.checkIfWvIsPresentById(data.activities, _this.form.activityId)) {
                        _this.showActivityResetNotification(_this.lng.translate(21005004, 'Tätigkeit'), (_b = (_a = previousWv === null || previousWv === void 0 ? void 0 : previousWv.activities.filter(function (x) { return x.objectId === _this.form.activityId; })[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
                        _this.form.activityId = _this.checkIfWvIsPresentById(data.activities, _this.defaultActivity) ? _this.defaultActivity : QMC.Common.Constants.DEFAULT_ACTIVITY_ID;
                    }
                    _this.activityMap = _this.$qui.selectAutoMap(data.activities, 'objectId', 'name');
                    _this.instituteMap = _this.$qui.selectAutoMap(data.instituteWvList, 'objectId', 'name');
                });
            };
            ArbeitszeitnachweisNewController.prototype.showActivityResetNotification = function (area, caption) {
                this.$qui.notify({
                    message: this.$qui.formatString(this.lng.translate(20016241, 'Die {0} {1} ist an dem Dokumentationsdatum ungültig'), area, caption),
                    title: this.$qui.formatString(this.lng.translate(0, 'Die {0} wurde zurückgesetzt'), area),
                    icon: "qm-icon-information",
                    status: "info",
                    timer: 8000
                });
            };
            ArbeitszeitnachweisNewController.prototype.checkIfWvIsPresentById = function (list, id) {
                for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                    var element = list_1[_i];
                    if (element.objectId == id)
                        return true;
                }
                return false;
            };
            ArbeitszeitnachweisNewController.prototype.getAlloCaseList = function () {
                var _this = this;
                this.arbeitszeitnachweisService.getAllocatableFlsCaseList().then(function (data) {
                    _this.cases = data;
                    _this.formatAllocatedCases();
                    _this.casesToShow = _this.currentfilter(_this.cases);
                });
            };
            ArbeitszeitnachweisNewController.prototype.getDetailData = function (id) {
                var _this = this;
                this.arbeitszeitnachweisService.getArbeitszeitnachweis(id).then(function (data) {
                    _this.formState = 'edit';
                    if (!data.activityId || data.activityId === QMC.Common.Constants.GUID_EMPTY)
                        data.activityId = _this.defaultActivity;
                    _this.form = data;
                    _this.loading = false;
                    _this.form.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    _this.form.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    _this.timeForm.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    _this.timeForm.dateTo = _this.$qui.createDateFromString(data.dateTo);
                    _this.institute = data.organizationName;
                    //override the isManualDuration when you get an azn with isManualTimeAllowed
                    if (!_this.timeForm.isManualTimeAllowed) {
                        _this.timeForm.isManualDuration = false;
                    }
                    else {
                        _this.timeForm.isManualDuration = data.isManualDuration;
                    }
                    var time = _this.$qui.convertDec(data.durationInHours);
                    _this.timeForm.hours = time[0];
                    _this.timeForm.minutes = time[1];
                    _this.formatAllocatedCases();
                    _this.form.isImpute = _this.form.imputeWvId === QMC.Common.Constants.WV_YES;
                    _this.events();
                    _this.getAznWvList();
                });
            };
            ArbeitszeitnachweisNewController.prototype.formatAllocatedCases = function () {
                var _this = this;
                if (this.cases === (null && undefined) || this.form.flsAllocations === (null && undefined))
                    return;
                this.form.flsAllocations = this.form.flsAllocations.map(function (x) { return (__assign(__assign({}, x), _this.cases.filter(function (y) { return y.billingRateObjectId === x.billingRateObjectId; })[0])); });
                this.cases = this.cases.filter(function (x) { return !_this.form.flsAllocations.some(function (y) { return y.billingRateObjectId === x.billingRateObjectId; }); });
                this.form.flsAllocations.watcherList = [];
                for (var i = 0; i < this.form.flsAllocations; i++) {
                    this.form.flsAllocations.watcherList.push(this.$scope.$watch('vm.form.flsAllocations[' + i + '].percentShare', function (newValue, oldValue) {
                        if (newValue !== oldValue)
                            _this.validate();
                    }));
                }
            };
            /**
            * currentFilter
            * @description Returns the current Filter
            * @param entry
            */
            ArbeitszeitnachweisNewController.prototype.currentfilter = function (list) {
                var _this = this;
                return list.filter(function (x) { return x.isCurrent || !_this.caseFilter.onlyCurrentCases; });
            };
            ArbeitszeitnachweisNewController.prototype.toggleShowCurrentOnly = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.userService.setUserSettings({ settings: [{ key: QMC.Common.UserSettingConstantsAndDefaults.FLS_CASE_FILTER_KEY, value: JSON.stringify(this.caseFilter) }] })];
                            case 1:
                                _a.sent();
                                this.casesToShow = this.currentfilter(this.cases);
                                this.$qui.scopeApply(this.$scope);
                                return [2 /*return*/];
                        }
                    });
                });
            };
            ArbeitszeitnachweisNewController.prototype.convertHours = function (hours, minutes) {
                return moment.duration(hours + ":" + minutes).asHours();
            };
            ArbeitszeitnachweisNewController = __decorate([
                QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisNewController'),
                QMC.Inject('$location', 'ArbeitszeitnachweisService', '$qui', '$scope', '$state', '$timeout', 'QmcIdentityService', 'UserService', 'QmcLanguageService', 'QmcPermissionService')
            ], ArbeitszeitnachweisNewController);
            return ArbeitszeitnachweisNewController;
        }());
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var ArbeitszeitnachweisOverviewController = /** @class */ (function () {
            /**
             * QMC.Arbeitszeitnachweis.AzwnController
             * @constructor
             * @param arbeitszeitnachweisService
             * @param $qui
             * @param $stateParams
             */
            function ArbeitszeitnachweisOverviewController($location, $qui, timeTrackingService, $scope) {
                this.timeTrackingService = timeTrackingService;
                this.$scope = $scope;
                this.displayTimeTrackingComponent = false;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                var parentScope = this.$scope.$parent;
                parentScope.overviewChild = this.$scope;
                this.tryGetLatestTimeStampItem();
            }
            ArbeitszeitnachweisOverviewController.prototype.tryGetLatestTimeStampItem = function () {
                var _this = this;
                this.timeTrackingService.checkTimeTrackingAvailable().then(function (data) {
                    if (data.isTimetrackingEnabled) {
                        _this.displayTimeTrackingComponent = true;
                        _this.getTimeStamp();
                    }
                });
            };
            ArbeitszeitnachweisOverviewController.prototype.getTimeStamp = function () {
                var _this = this;
                this.timeTrackingService.getLatestTimeTrackingDetailItem().then(function (item) {
                    _this.latestTimeStamp = item.timeStamp;
                    if (item.punchStatusId.toUpperCase() === Arbeitszeitnachweis.TimeTrackingConstants.TIME_TRACKING_STAMP_IN) {
                        _this.isCurrentlyTracking = true;
                        _this.refreshWidget(false);
                    }
                    else {
                        _this.isCurrentlyTracking = false;
                        _this.refreshWidget(true);
                    }
                });
            };
            ArbeitszeitnachweisOverviewController.prototype.stopTimeTracking = function (comment) {
                var _this = this;
                this.timeTrackingService.postTimeTrackingStop(comment).then(function () {
                    console.log("time tracking has been stopped...");
                    _this.getTimeStamp();
                });
            };
            ArbeitszeitnachweisOverviewController.prototype.startTimeTracking = function (comment) {
                var _this = this;
                this.timeTrackingService.postTimeTrackingStart(comment).then(function () {
                    console.log("time tracking has been started...");
                    _this.getTimeStamp();
                });
            };
            ArbeitszeitnachweisOverviewController.prototype.refreshWidget = function (didStampOut) {
                this.$scope.$$childHead.$root.refreshWidget(didStampOut);
            };
            ArbeitszeitnachweisOverviewController = __decorate([
                QMC.Controller('QMC.Arbeitszeitnachweis', 'ArbeitszeitnachweisOverviewController'),
                QMC.Inject('$location', '$qui', 'TimeTrackingService', '$scope')
            ], ArbeitszeitnachweisOverviewController);
            return ArbeitszeitnachweisOverviewController;
        }());
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var WorktimeOverviewDirective = /** @class */ (function () {
            function WorktimeOverviewDirective(arbeitszeitnachweisService, $qui, permissionService, userService, lng, $filter) {
                var _this = this;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.permissionService = permissionService;
                this.userService = userService;
                this.lng = lng;
                this.$filter = $filter;
                this.restrict = 'AE';
                this.templateUrl = './Arbeitszeitnachweis/WorktimeOverviewDirective';
                this.scope = {
                    personId: '=?',
                    date: '=?',
                    organisationId: '=?',
                    timeFormattingStyle: '=?',
                    targetView: '=?'
                };
                this.controller = ['$scope', function (scope) {
                        _this.$scope = scope;
                        scope.loading = true;
                        _this.userService.getUserSettings(["SHOWTIMEINSTEADOFDECIMAL"]).then(function (data) {
                            scope.showTime = data[0].value === "" ? QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL : data[0].value.toLowerCase() === "true";
                        });
                        _this.arbeitszeitnachweisService.getWorkingTimeOverviewOptions(new Date(), $('#session').data().personId).then(function (data) {
                            _this.$scope.workingtimeSettings = data;
                            scope.supportedViewsMap = data.supportedTargetViews.map(function (x) { return ({ text: x.text, value: x.id + '' }); });
                        });
                        var setupConf = function () {
                            var _a, _b, _c;
                            scope.conf = {
                                date: (_a = scope.date) !== null && _a !== void 0 ? _a : new Date(),
                                person: (_b = scope.personId) !== null && _b !== void 0 ? _b : $('#session').data().personId,
                                organisation: scope.organisationId,
                                targetView: (_c = scope.targetView) !== null && _c !== void 0 ? _c : '0'
                            };
                        };
                        scope.$watch('date', function () { setupConf(); }, true);
                        scope.$watch('personId', function () { setupConf(); scope.workingtimeData = undefined; }, true);
                        setupConf();
                        _this.getCalculation();
                        scope.organisationTabChange = function (organisationId) {
                            scope.conf.organisation = organisationId;
                        };
                        scope.formatCaption = function (item, isFirstElement) {
                            if (isFirstElement)
                                return item.caption;
                            else if (item.isSummaryItem)
                                return "= " + item.caption;
                            else if (item.isNegative)
                                return "- " + item.caption;
                            else
                                return "+ " + item.caption;
                        };
                        scope.formatTime = function (number) {
                            if (scope.showTime) {
                                var hours = Math.floor(Math.abs(number));
                                var minutes = Math.round(Math.abs(number * 60 % 60));
                                if (minutes < 10)
                                    minutes = "0" + minutes;
                                if (minutes > 59) {
                                    minutes = "00";
                                    hours++;
                                }
                                return (number < 0 ? '-' : '') + hours + ":" + minutes;
                            }
                            else {
                                return _this.$filter('number')(number, 2);
                            }
                        };
                        scope.formatWorktimeTooltip = function (item, propertyName) {
                            if ((item === null || item === void 0 ? void 0 : item.detailItems) === null)
                                return "";
                            var toolTip = "";
                            item.detailItems.forEach(function (detail) { return toolTip += detail.caption + ": " + scope.formatTime(detail[propertyName]) + "\r\n"; });
                            return toolTip;
                        };
                        scope.createThresholdTooltip = function (item) {
                            if (!item)
                                return '';
                            return [_this.lng.translate(20030007, 'Oberer positiver Grenzwert') + ": " + scope.formatTime(item.positiveUpperThreshold),
                                _this.lng.translate(20030008, 'Unterer positiver Grenzwert') + ": " + scope.formatTime(item.positiveLowerThreshold),
                                _this.lng.translate(20030009, 'Oberer negativer Grenzwert') + ": " + scope.formatTime(item.negativeUpperThreshold),
                                _this.lng.translate(20030010, 'Unterer negativer Grenzwert') + ": " + scope.formatTime(item.negativeLowerThreshold)].join('\r\n');
                        };
                    }];
                this.link = function (scope) {
                    scope.$watch('conf', function (oldVal, newVal) {
                        if (JSON.stringify(oldVal) !== JSON.stringify(newVal))
                            _this.getCalculation();
                    }, true);
                };
            }
            WorktimeOverviewDirective.prototype.getCalculation = function () {
                var _this = this;
                this.$scope.loading = true;
                this.arbeitszeitnachweisService.getWorkingtimeCalculation(this.$scope.conf.date, this.$scope.conf.person, this.$scope.conf.organisation, parseInt(this.$scope.conf.targetView))
                    .then(function (data) {
                    _this.$scope.workingtimeData = data;
                    _this.$scope.loading = false;
                    // set traffic light
                    setTimeout(function () {
                        switch (_this.$scope.workingtimeData.overtime.status) {
                            case 1:
                                $('#signalLight').removeClass('red');
                                $('#signalLight').addClass('yellow');
                                $('#signalLight').removeClass('green');
                                break;
                            case 2:
                                $('#signalLight').removeClass('red');
                                $('#signalLight').removeClass('yellow');
                                $('#signalLight').addClass('green');
                                break;
                            default:
                                $('#signalLight').addClass('red');
                                $('#signalLight').removeClass('yellow');
                                $('#signalLight').removeClass('green');
                                break;
                        }
                    });
                });
            };
            WorktimeOverviewDirective = __decorate([
                QMC.Directive('QMC.Arbeitszeitnachweis', 'qmWorktimeOverview', ['ArbeitszeitnachweisService', '$qui', 'QmcPermissionService', 'UserService', 'QmcLanguageService', '$filter'])
            ], WorktimeOverviewDirective);
            return WorktimeOverviewDirective;
        }());
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var ManualOvertimeService = /** @class */ (function (_super) {
            __extends(ManualOvertimeService, _super);
            function ManualOvertimeService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/ManualOvertime';
                return _this;
            }
            ManualOvertimeService.prototype.getOvertimeWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            ManualOvertimeService.prototype.getManualOvertimeList = function (contractId, dateFrom, dateTo) {
                return _super.prototype.getPagination.call(this, this.modulePath, { contractId: contractId, dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            ManualOvertimeService.prototype.getSingleManualOvertimeList = function (id) {
                return _super.prototype.getPagination.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            ManualOvertimeService.prototype.postManualOvertime = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (e) {
                    return e;
                });
            };
            ManualOvertimeService.prototype.putManualOvertime = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id, data).then(function (e) {
                    return e;
                });
            };
            ManualOvertimeService.prototype.deleteManualOvertime = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/' + id).then(function (data) {
                    return data;
                });
            };
            ManualOvertimeService = __decorate([
                QMC.Service('QMC.Arbeitszeitnachweis', 'ManualOvertimeService'),
                QMC.Inject('$http', '$q')
            ], ManualOvertimeService);
            return ManualOvertimeService;
        }(QMC.Common.BaseService));
        Arbeitszeitnachweis.ManualOvertimeService = ManualOvertimeService;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        var ManualOvertimeListController = /** @class */ (function () {
            /**
             * QMC.ManualOvertime.List.Controller
             * @constructor
             * @param manualovertimeService
             * @param $qui
             * @param $stateParams
             */
            function ManualOvertimeListController($location, $scope, manualovertimeService, arbeitszeitnachweisService, $qui, $stateParams, userService, permissionService, $timeout) {
                var _this = this;
                this.$location = $location;
                this.$scope = $scope;
                this.manualovertimeService = manualovertimeService;
                this.arbeitszeitnachweisService = arbeitszeitnachweisService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.userService = userService;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.ui = new Arbeitszeitnachweis.UserInterfaceOvertime();
                this.allowTableExport = false;
                this.loadingWt = true;
                this.filter = {
                    dateFrom: moment().startOf('months').toDate(),
                    dateTo: moment().endOf('months').toDate(),
                };
                this.showMonthFilter = true;
                $qui.init($qui.getSectionColor("/azn/overview"), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                //ObjectType: ÜberstundenManuell
                permissionService.getPermissionsByObjectTypes([890005, 890007]).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.modifyPermission = data[0].modify && data[0].moduleAccess;
                    _this.view = data[0].view && data[0].moduleAccess;
                    _this.canApprove = data[1].openFile;
                    _this.allowTableExport = data[0].print;
                    _this.getOvertimeList();
                    _this.getCalculation();
                    _this.init();
                    _this.events();
                });
            }
            /**
             * init
             * @description Init the filter
             */
            ManualOvertimeListController.prototype.init = function () {
                var _this = this;
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getOvertimeList();
                });
                this.formState = "new";
                this.form = {
                    contractId: null,
                    date: new Date(),
                    reasonId: null,
                    approvedId: this.canApprove ? 'a8d072b9-8cdb-4e91-810b-df609c6946c3' : 'efd58886-58e4-4562-adcb-27e677167767',
                    approvedPersonId: null,
                    comment: "",
                    hours: 0,
                    canApprove: !this.canApprove,
                    objectId: null
                };
            };
            ManualOvertimeListController.prototype.events = function () {
                var _this = this;
                this.filterWatcher = this.$scope.$watchCollection('vm.filter', function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    _this.getOvertimeList();
                });
            };
            ManualOvertimeListController.prototype.addOvertime = function () {
                var _this = this;
                this.loading = true;
                this.manualovertimeService.postManualOvertime(this.form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getOvertimeList();
                    _this.formState = "new";
                    _this.getCalculation();
                    _this.loading = false;
                }).catch(function () { _this.loading = false; });
            };
            ManualOvertimeListController.prototype.editOvertime = function (input) {
                var _this = this;
                this.manualovertimeService.getSingleManualOvertimeList(input.objectId).then(function (data) {
                    _this.formState = "edit";
                    _this.form = data;
                    _this.form.date = _this.$qui.createDateFromString(data.date);
                    // do not allow modification of approved times, unless you can approve as well
                    if (data.approvedId !== null && _this.form.approvedId.toLowerCase() === QMC.Common.Constants.APPROVAL_APRROVED_ID && !_this.canApprove)
                        _this.modify = false;
                    else
                        _this.modify = _this.modifyPermission;
                });
            };
            ManualOvertimeListController.prototype.putOvertime = function (input) {
                var _this = this;
                this.loading = true;
                this.manualovertimeService.putManualOvertime(this.form.objectId, this.form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getOvertimeList();
                    _this.formState = "new";
                    _this.getCalculation();
                    _this.loading = false;
                }).catch(function () { _this.loading = false; });
            };
            ManualOvertimeListController.prototype.deleteOvertime = function (input) {
                var _this = this;
                this.manualovertimeService.getSingleManualOvertimeList(input.objectId).then(function (data) {
                    // do not allow modification of approved times, unless you can approve as well
                    if (data.approvedId !== null && data.approvedId.toLowerCase() === QMC.Common.Constants.APPROVAL_APRROVED_ID && !_this.canApprove)
                        return;
                    _this.manualovertimeService.deleteManualOvertime(input.objectId).then(function (data) {
                        _this.ui.notify(_this.ui.deleteNote);
                        _this.formState = "new";
                        _this.getOvertimeList();
                        _this.getCalculation();
                    });
                });
            };
            ManualOvertimeListController.prototype.getApprovedWvList = function () {
                var _this = this;
                return this.manualovertimeService.getOvertimeWv().then(function (data) {
                    return _this.ui.select(data.approvedWvList, { value: "objectId", text: "name" });
                });
            };
            ManualOvertimeListController.prototype.getReasonWvList = function () {
                var _this = this;
                return this.manualovertimeService.getOvertimeWv().then(function (data) {
                    return _this.ui.select(data.reasonWvList, { value: "objectId", text: "name" });
                });
            };
            ManualOvertimeListController.prototype.getOvertimeList = function () {
                var _this = this;
                /* Deregister Watcher */
                if (this.filterWatcher)
                    this.filterWatcher();
                this.loading = true;
                this.manualovertimeService.getManualOvertimeList(null, this.filter.dateFrom, this.filter.dateTo).then(function (data) {
                    for (var i = 0; i < data.length; i++) {
                        data[i].dateString = moment(data[i].date).format("DD.MM.YYYY");
                    }
                    _this.ui.overtimeTable.data = data;
                    _this.loading = false;
                    _this.$timeout(function () {
                        _this.$qui.functionWaiter("ui.createForm", _this);
                        _this.$qui.functionWaiter("ui.createTable", _this);
                    });
                });
            };
            ManualOvertimeListController.prototype.getCalculation = function () {
                var _this = this;
                this.loadingWt = true;
                var currentDate = new Date();
                currentDate.setHours(23, 59, 59, 999);
                this.arbeitszeitnachweisService.getWorkingtimeCalculation(currentDate).then(function (data) {
                    _this.workingtimeData = data;
                    _this.loadingWt = false;
                    // set traffic light
                    setTimeout(function () {
                        switch (_this.workingtimeData.overtime.status) {
                            case 1:
                                $('#red').removeClass('activeLight');
                                $('#yellow').addClass('activeLight');
                                $('#green').removeClass('activeLight');
                                break;
                            case 2:
                                $('#red').removeClass('activeLight');
                                $('#yellow').removeClass('activeLight');
                                $('#green').addClass('activeLight');
                                break;
                            default:
                                $('#red').addClass('activeLight');
                                $('#yellow').removeClass('activeLight');
                                $('#green').removeClass('activeLight');
                                break;
                        }
                    }, 500);
                });
            };
            ManualOvertimeListController = __decorate([
                QMC.Controller('QMC.Arbeitszeitnachweis', 'ManualOvertimeListController'),
                QMC.Inject('$location', '$scope', 'ManualOvertimeService', 'ArbeitszeitnachweisService', '$qui', '$stateParams', 'UserService', 'QmcPermissionService', '$timeout')
            ], ManualOvertimeListController);
            return ManualOvertimeListController;
        }());
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Arbeitszeitnachweis;
    (function (Arbeitszeitnachweis) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterfaceOvertime = /** @class */ (function (_super) {
            __extends(UserInterfaceOvertime, _super);
            function UserInterfaceOvertime() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * Medicament table
                 * @memberOf UserInterface
                 */
                _this.overtimeTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dauer": {
                            "label": "hours",
                            "dType": "Number",
                            "lngTag": "20000075"
                        },
                        "Grund": {
                            "label": "reason",
                            "dType": "string",
                            "lngTag": "20000285"
                        },
                        "Genehmigt": {
                            "label": "approved",
                            "dType": "string",
                            "lngTag": "20027003"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#overtimeModal",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-history2"
                        },
                        "text": {
                            "label": "dateString",
                            "dType": "string",
                        },
                        "subtext": [
                            {
                                "label": "hours",
                                "dType": "Number"
                            },
                            {
                                "label": "reason",
                                "dType": "string"
                            },
                            {
                                "label": "approved",
                                "dType": "string"
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "openModal": "true",
                                "targetModal": "#overtimeModal",
                                "click": "editOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteOvertime",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                _this.overtimeForm = {
                    form: [{
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            lngTag: 20000045,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte geben Sie ein gültiges Datum ein.",
                                messageTag: 21003015
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            label: "Stunden",
                            type: "Number",
                            minValue: -1000,
                            model: "hours",
                            lngTag: 20000219,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        },
                        {
                            placeholder: "Grund",
                            label: "Grund",
                            type: "Select",
                            dataSource: "getReasonWvList",
                            model: "reasonId",
                            lngTag: 20000285,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-question-circle"
                            }
                        }, {
                            placeholder: "Genehmigt",
                            label: "Genehmigt",
                            type: "Select",
                            dataSource: "getApprovedWvList",
                            model: "approvedId",
                            lngTag: 20027003,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-exclamation-circle"
                            },
                            events: {
                                hide: "canApprove"
                            }
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putOvertime",
                        post: "addOvertime",
                    }
                };
                return _this;
            }
            return UserInterfaceOvertime;
        }(QMC.Common.UserInterface));
        Arbeitszeitnachweis.UserInterfaceOvertime = UserInterfaceOvertime;
    })(Arbeitszeitnachweis = QMC.Arbeitszeitnachweis || (QMC.Arbeitszeitnachweis = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Arbeitszeitnachweis/qmc.arbeitszeitnachweis.js.map
